module.exports = __webpack_public_path__ + "static/img/tx1.a9d4f46e.png";